<script>
import StoreTrainingMenuForm from '@app/components/StoreTrainingMenuForm.vue';
import StoreInternalLinksForm from '@app/components/StoreInternalLinksForm.vue';
import StoreDisplayTimeForm from '@app/components/StoreDisplayTimeForm.vue';

export default {
  components: {
    StoreTrainingMenuForm,
    StoreInternalLinksForm,
    StoreDisplayTimeForm,
  },
  head: {
    title: 'Apparence de l\'espace apprenant',
  },
  computed: {
    authStore() {
      return this.$store.getters['auth/store'];
    },
  },
};
</script>

<template>
  <section>
    <StoreTrainingMenuForm />
    <StoreDisplayTimeForm />
    <StoreInternalLinksForm />
  </section>
</template>
